import { Message } from 'element-ui';
import dayjs from 'dayjs';
export default {
    install(Vue) {
        Vue.filter('dateFormat', function (val) {
            if (!val) return '';
            return dayjs(val).format('YYYY-MM-DD HH:mm');
        });
        Vue.prototype.$formatDate = function (val, format = 'YYYY-MM-DD HH:mm') {
            if (!val) return '';
            return dayjs(val).format(format);
        };
        Vue.prototype.$msg = {
            success(message = '', duration = 2000) {
                return new Promise((resolve) => {
                    Message({
                        message,
                        duration,
                        type: 'success',
                        onClose: () => {
                            resolve()
                        }
                    })
                })
            },
            error(message = '', duration = 2000) {
                return new Promise((reject) => {
                    Message({
                        message,
                        duration,
                        type: 'error',
                        onClose: () => {
                            reject()
                        }
                    })
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/global.js